<template>
	<v-row no-gutters align="center">
		<v-col cols="auto" class="text-left field_name">
			<h2 class="med pr-3 pl-1">Action</h2>
		</v-col>
		<v-col>
			<v-select
				outlined
				single-line
				hide-details
				:items="appTotalActions"
				v-model="localAction"
				class="slct reg ac"
				height="50"
				placeholder="Choose action"
				:menu-props="{ contentClass: 'cust_slct_list', offsetY: true, bottom: true, maxHeight: '70vh' }"
				item-text="title"
				item-value="id"
				append-icon="mdi-chevron-down"
			>
				<template v-slot:item="{ item }">
					<v-row no-gutters>
						<v-col cols="12" class="py-3 px-6">
							<h3 class="tit">{{ item.title }}</h3>
							<h5 class="desc mt-1">{{ item.description || '' }}</h5>
						</v-col>
						<v-col cols="12">
							<v-divider class="mt-1" style="background: #dce0e9 !important"></v-divider>
						</v-col>
					</v-row>
				</template>
			</v-select>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getServiceActionsByVersion } from '@/store/modules/apps/getters';

export default {
	name: 'BlockEditorIntegrationAction',
	props: {},
	data: () => ({}),
	mounted() {},
	components: {},
	watch: {},
	computed: {
		...mapGetters([getServiceActionsByVersion.fullPath]),
		...mapGetters('selectedNode', ['editNode']),
		localAction: {
			set(value) {
				this.updateNodeAction(value);
			},
			get() {
				return this.editNode ? this.editNode.action : null;
			},
		},
		appTotalActions() {
			if (!this.editNode) {
				return [];
			}
			const actions = this[getServiceActionsByVersion.fullPath](this.editNode.service, this.editNode.service_version) || [];
			return actions.filter((action) => !action.hidden);
		},
	},
	methods: {
		...mapActions('selectedNode', ['setParamInEditNode']),
		updateNodeAction(action) {
			this.setParamInEditNode({ key: 'action', value: action });
		},
	},
};
</script>

<style scoped>
.integration {
}

h2.med {
	font-size: 16px;
	font-weight: 600;
	color: #292829;
}
.ac {
	border-radius: 4px !important;
	border-color: #d6ddeb;
}
.ac_card {
	width: 32px;
	height: 32px;
	border-radius: 7px !important;
}
h3.tit {
	color: #5c8df5;
	font-weight: 500;
	font-size: 14px;
}
h5.desc {
	font-size: 12px;
	font-weight: 300;
	color: #464b57;
}
.v-list-item {
	padding: 0px;
}
h3 {
	color: #354052;
	font-size: 16px;
	font-weight: 400;
}
</style>
